import React, { useState } from "react";
import {
  TextField,
  Button,
  Box,
  Paper,
  Alert,
  Link,
  Typography,
} from "@mui/material";
import { useAuth } from "../context/AuthContext";

const LoginPage = () => {
  const [cuit, setCuit] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(cuit, password);
    } catch (err) {
      setError(err.message);
    }finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        width: '100vw',
        bgcolor: '#FBF7EF',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
      }}
    >
      <Paper
        elevation={3}
        sx={{
          padding: 4,
          borderRadius: 3,
          backgroundColor: "#fafafa",
          width: '100%',
          maxWidth: 400,
          mx: 2,
        }}
      >
        {/* Título centrado */}
        <Typography
          variant="h5"
          align="center"
          sx={{ color: '#003B23', fontWeight: 600, mb: 2 }}
        >
          Iniciar sesión
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <Box component="form" onSubmit={handleLogin} sx={{ mt: 2 }}>
          <TextField
            label="Cuit"
            variant="outlined"
            fullWidth
            margin="normal"
            value={cuit}
            onChange={(e) => setCuit(e.target.value)}
            required
            sx={{
              '& label.Mui-focused': { color: '#698577' },
              '& .MuiOutlinedInput-root.Mui-focused fieldset': {
                borderColor: '#698577',
              },
            }}
          />

          <TextField
            label="Contraseña"
            type="password"
            variant="outlined"
            fullWidth
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            sx={{
              '& label.Mui-focused': { color: '#698577' },
              '& .MuiOutlinedInput-root.Mui-focused fieldset': {
                borderColor: '#698577',
              },
            }}
          />
            {loading ? (
              <>
                <Typography variant="subtitle1" sx={{ fontWeight: 600, color: "#003B23" }}>
                Ingresando...
                </Typography>
              </>
            ) : ""}

          <Button
            type="submit"
            variant="contained" 
            fullWidth
            sx={{
              mt: 2,
              py: 1.5,
              backgroundColor: '#003B23',
              '&:hover': {
                backgroundColor: '#3b7b61',
              },
            }}
          >
            Iniciar sesión
          </Button>
          <button type="submit" style={{ display: 'none' }} aria-hidden="true" />
          <Box  sx={{ mt: 1, textAlign: 'right' }}>
            <Link 
              href="/ForgotPass" 
              variant="body2" 
              underline="hover"
              sx={{ color: '#003B23', '&:hover': { color: '#3b7b61' } }}
            >
              ¿Olvidaste tu contraseña?
            </Link>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default LoginPage;
